export default class Api {
  static CSRF = '';

  static HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  static HOST = '';

  static OPTIONS = {
    // Cross-domain requests won't work without this:
    credentials: 'include',
  };

  static STORYBOARD_ID = -1;

  static WWW = '';

  static addChapter(chapter) {
    return fetch(`${Api.HOST}storyboards/chapter/`, {
      body: JSON.stringify({
        ...chapter,
        storyboard: Api.STORYBOARD_ID,
      }),
      headers: {
        ...Api.HEADERS,
        'X-CSRFToken': Api.CSRF,
      },
      method: 'POST',
      ...Api.OPTIONS,
    });
  }

  static addLogo(logo) {
    const formData = new FormData();
    formData.append('logo', logo);
    return fetch(`${Api.HOST}storyboards/${Api.STORYBOARD_ID}`, {
      body: formData,
      headers: {
        'X-CSRFToken': Api.CSRF,
      },
      method: 'PATCH',
      ...Api.OPTIONS,
    });
  }

  static checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }

  static deleteChapter(chapter) {
    return fetch(`${Api.HOST}storyboards/chapter/${chapter.id}`, {
      headers: {
        ...Api.HEADERS,
        'X-CSRFToken': Api.CSRF,
      },
      method: 'DELETE',
      ...Api.OPTIONS,
    });
  }

  static deleteLogo(logo) {
    return fetch(logo.url, {
      headers: {
        'X-CSRFToken': Api.CSRF,
      },
      method: 'DELETE',
      ...Api.OPTIONS,
    });
  }

  static editChapter(chapter) {
    return fetch(`${Api.HOST}storyboards/chapter/${chapter.id}`, {
      body: JSON.stringify({
        ...chapter,
      }),
      headers: {
        ...Api.HEADERS,
        'X-CSRFToken': Api.CSRF,
      },
      method: 'PATCH',
      ...Api.OPTIONS,
    });
  }

  static editTheme(configuration) {
    return fetch(`${Api.HOST}storyboards/${Api.STORYBOARD_ID}`, {
      body: JSON.stringify({
        ...configuration,
      }),
      headers: {
        ...Api.HEADERS,
        'X-CSRFToken': Api.CSRF,
      },
      method: 'PATCH',
      ...Api.OPTIONS,
    });
  }

  static fetchChapterReport(chapterId) {
    return fetch(`${Api.HOST}reports?chapter=${chapterId}`, Api.OPTIONS);
  }

  static fetchReportPreview(params, reportType) {
    return fetch(`${Api.WWW}reports/preview/form?type=${reportType.id}`, {
      body: params,
      cache: false,
      headers: {
        ...Api.HEADERS,
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'X-CSRFToken': Api.CSRF,
      },
      method: 'POST',
      processData: false,
      ...Api.OPTIONS,
    });
  }

  static positionChapters(chapters) {
    return fetch(`${Api.HOST}storyboards/${Api.STORYBOARD_ID}/positions`, {
      body: JSON.stringify({
        chapters,
      }),
      headers: {
        ...Api.HEADERS,
        'X-CSRFToken': Api.CSRF,
      },
      method: 'POST',
      ...Api.OPTIONS,
    });
  }
}
